import { listResponsiveConditions, toResponsiveValueRecord, } from './breakpoints';
const TRUE_CLASS_SUFFIX_BY_AXIS = Object.freeze({
    attached: 'attached',
    checked: 'checked',
    disabled: 'disabled',
    fullWidth: 'full-width',
    invalid: 'invalid',
    interactive: 'interactive',
    loading: 'loading',
    readOnly: 'read-only',
    required: 'required',
    selected: 'selected',
    showColumnBorder: 'column-border',
    stickyHeader: 'sticky-header',
    striped: 'striped',
});
const COMPONENT_STYLE_NAME_PATTERN = /^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/;
export function normalizeComponentStyleName(name) {
    return name
        .trim()
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .toLowerCase();
}
export function isComponentStyleName(name) {
    return COMPONENT_STYLE_NAME_PATTERN.test(name);
}
function normalizeVariantClassValue(axis, value) {
    if (value === undefined || value === null || value === false) {
        return undefined;
    }
    if (value === true) {
        return TRUE_CLASS_SUFFIX_BY_AXIS[axis] ?? 'true';
    }
    const stringValue = String(value).trim();
    return stringValue.length > 0 ? stringValue : undefined;
}
function buildVariantClassTokens(baseClass, axis, value, fallbackValue, breakpointInput) {
    const responsiveValue = toResponsiveValueRecord(value, breakpointInput);
    if (responsiveValue) {
        const classes = [];
        const baseValue = Object.prototype.hasOwnProperty.call(responsiveValue, 'base')
            ? responsiveValue.base
            : fallbackValue;
        const baseToken = normalizeVariantClassValue(axis, baseValue);
        if (baseToken) {
            classes.push(`${baseClass}--${baseToken}`);
        }
        for (const breakpoint of listResponsiveConditions(responsiveValue, breakpointInput).filter((entry) => entry !== 'base')) {
            if (!Object.prototype.hasOwnProperty.call(responsiveValue, breakpoint)) {
                continue;
            }
            const token = normalizeVariantClassValue(axis, responsiveValue[breakpoint]);
            if (token) {
                classes.push(`${breakpoint}:${baseClass}--${token}`);
            }
        }
        return classes;
    }
    const token = normalizeVariantClassValue(axis, value ?? fallbackValue);
    return token ? [`${baseClass}--${token}`] : [];
}
export function buildResponsiveVariantClassNames(baseClass, variants, fallbackVariants = {}, breakpointInput) {
    return Object.entries(variants).flatMap(([axis, value]) => buildVariantClassTokens(baseClass, axis, value, fallbackVariants[axis], breakpointInput));
}
//# sourceMappingURL=component-classnames.js.map